<div class="container-fluid">
   
                <div class="row">
                    <div class="card-body">
                        <div class="row flex-row-reverse">
                            <div class="col-12">
                                <button class="btn btn-secondary" href="javascript:void(0);"  *ngIf="caseService.case && caseService.case.settings.allowEditInvestigation"
                                    (click)="CreateViolation(AddViolation);">
                                    <i class="fa fa-plus-circle"></i>
                                    <span>{{'AddViolation' | translate}}</span>
                                </button>
                            </div>
                            <div class="card">
                                <table class="table table-striped mt-3">
                                    <thead class="thead-dark">
                                        <tr>
                                            <th>{{ "mainViolationTypeName" | translate }}</th>
                                            <th>{{ "subViolationTypeName" | translate }}</th>
                                            <th>{{'measurmentUnit'|translate}}</th>
                                            <th>{{ "quantity" | translate }}</th>
                                            <th>{{ "place" | translate }}</th>
                                            <th>{{ "material" | translate }}</th>
                                           
                                            <th scope="col"> {{"Show" | translate }}</th>
                                            <th scope="col" *ngIf="caseService.case && caseService.case.settings.allowEditInvestigation">{{"Edit" | translate}}</th>
                                            <th scope="col" *ngIf="caseService.case && caseService.case.settings.allowEditInvestigation">{{"Delete" | translate}}</th>

                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let violation of ViolationsArr">
                                            <td>{{ violation.mainViolationTypeName }}</td>
                                            <td>{{ violation.subViolationTypeName }}</td>
                                            <td>{{ violation.measurmentUnitName }}</td>
                                            <td>{{ violation.quantity }}</td>
                                            <td>{{ violation.place }}</td>
                                            <td>{{ violation.material }}</td>

                                            <td>
                                                <a (click)="EditViolation(violation,ShowViolation)" href="javascript:void(0);">
                                                    <i class="fa fa-eye"></i>
                                                </a>
                                            </td>
                                            <td *ngIf="caseService.case && caseService.case.settings.allowEditInvestigation">
                                                <a (click)="EditViolation(violation,AddViolation)" href="javascript:void(0);">
                                                    <i class="fa fa-edit"></i>
                                                </a>
                                            </td>
                                            <td *ngIf="caseService.case && caseService.case.settings.allowEditInvestigation">
                                                <a (click)="DeleteViolation(violation.violationId, mymodal)"
                                                    href="javascript:void(0);">
                                                    <i class="fa fa-trash"></i>
                                                </a>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
      

<!-- اضافة وتعديل  مخالفة -->

<ng-template #AddViolation let-modal>
    <div class="modal-header">
        <h4 *ngIf="isInsert==true" class="modal-title">
            {{ 'AddViolation' | translate }}
        </h4>
        <h4 *ngIf="isInsert==false" class="modal-title">
            {{ 'EditViolation' | translate }}
        </h4>
        <i style="font-size: 20px;" class="fa fa-close" (click)="modal.dismiss('Cross click');"></i>
    </div>
    <form novalidate="">
        <div class="modal-body">
            <div class="form-group  row">
                <div class="col-12 offset-1 ">
                    <div class="card rounded-2  flex-md-row row">
                        <div class="form-group m-1 row">
                            <div class="col-lg-11">
                                <div class="divformlabel">
                                    <label for="mainViolationType">{{'mainViolationType'|translate}}</label>
                                    <span *ngIf="mainViolationType.invalid" class="alert" style="color: red;
                                    white-space: nowrap;
                                    line-height: 0;
                                    padding: 0;
                                    margin-top: 8px;">
                                        <span *ngIf="mainViolationType.errors?.required">*</span>
                                    </span>
                                </div>
                                <ng-select [readonly]="isAdd" #mainViolationType="ngModel"
                                    (change)="getSubViolation($event)" id="mainViolationType"
                                    class="form-control-select" [items]="MainViolationsArr" bindLabel="violationName"
                                    bindValue="violationTypeId" [(ngModel)]="mainViolationTypeId"
                                    [ngModelOptions]="{ standalone: true }"
                                    placeholder="{{'mainViolationType' | translate}}" required>
                                </ng-select>
                            </div>
                         
                        </div>
                        <div class="form-group row m-1 ">
                            <div class="col-11">
                                <label for="subViolationType"> {{'subViolationType' | translate}} </label>
                               
                                <ng-select [readonly]="!mainViolationTypeId" (change)="getSubViolationDesc($event)"
                                    #subViolationType="ngModel" id="subViolationType" class="form-control-select"
                                    [items]="SubViolationsArr" bindLabel="violationName" bindValue="violationTypeId"
                                    [(ngModel)]="subViolationTypeId" [ngModelOptions]="{ standalone: true }"
                                    placeholder="{{'subViolationType' | translate}}" >
                                </ng-select>
                            </div>
                            

                        </div>


                        <div class="form-group col-lg-11 m-1">
                            <div class="divformlabel">
                                <label>{{ "violationDescription" | translate }}</label>
                            </div>
                            <textarea [readonly]="subViolationTypeId" #violationDescription="ngModel"
                                name="violationDescription" id="violationDescription"
                                [(ngModel)]="SubViolationDescription" type="text" class="form-control"
                                placeholder="{{ 'violationDescription' | translate }}"></textarea>

                        </div>
                        <div class="form-group m-1 row">
                            <div class="col-6">
                                <label for="place"> {{'place' | translate}} </label>
                                <span *ngIf="place.invalid" class="alert" style="
                                                        color: red;
                                                        white-space: nowrap;
                                                        line-height: 0;
                                                        padding: 0;
                                                        margin-top: 8px;
                                                      ">
                                    <span *ngIf="place.errors?.required">*</span>
                                </span>
                                <input #place="ngModel" required name="place" id="place" [(ngModel)]="Place" type="text"
                                    class="form-control" placeholder="{{ 'place' | translate }}" />

                            </div>
                            <div class="col-6">
                                <label for="Quantity"> {{'quantity' | translate}} </label>
                                <span *ngIf="Quantity.invalid" class="alert" style="
                                                        color: red;
                                                        white-space: nowrap;
                                                        line-height: 0;
                                                        padding: 0;
                                                        margin-top: 8px;
                                                      ">
                                    <span *ngIf="Quantity.errors?.required">*</span>
                                </span>
                                <input #Quantity="ngModel" required name="Quantity" id="Quantity" [(ngModel)]="quantity"
                                    type="text" (keypress)="numberOnly($event)" class="form-control"
                                    placeholder="{{ 'quantity' | translate }}" />

                            </div>
                        </div>
                        <div class="form-group m-1 row">
                            <div class="col-6">
                                <label for="initalValue"> {{'InitalValue' | translate}} </label>
                                <span *ngIf="initalValue.invalid" class="alert" style="
                                                        color: red;
                                                        white-space: nowrap;
                                                        line-height: 0;
                                                        padding: 0;
                                                        margin-top: 8px;
                                                      ">
                                    <span *ngIf="initalValue.errors?.required">*</span>
                                </span>
                                <input (keypress)="numberOnly($event)" #initalValue="ngModel" name="initalValue"
                                    id="initalValue" [(ngModel)]="InitalValue" type="text" class="form-control"
                                    placeholder="{{ 'InitalValue' | translate }}" />

                            </div>
                            <div class="col-6">
                                <label for="location"> {{'Location' | translate}} </label>

                                <input #location="ngModel" name="location" id="location" [(ngModel)]="Location"
                                    type="text" class="form-control" placeholder="{{ 'Location' | translate }}" />

                            </div>
                        </div>
                        <div class="form-group m-1 row">
                            <div class="col-6">
                                <div class="divformlabel">
                                    <label for="measurmentUnit">{{'measurmentUnit'|translate}}</label>
                                    <span *ngIf="measurmentUnit.invalid" class="alert" style="color: red;
                                    white-space: nowrap;
                                    line-height: 0;
                                    padding: 0;
                                    margin-top: 8px;">
                                        <span *ngIf="measurmentUnit.errors?.required">*</span>
                                    </span>
                                </div>
                                <ng-select #measurmentUnit="ngModel" id="measurmentUnit" class="form-control-select"
                                    [items]="measurmentunitArr" bindLabel="text" bindValue="id"
                                    [(ngModel)]="measurmentUnitId" [ngModelOptions]="{ standalone: true }"
                                    placeholder="{{'measurmentUnit' | translate}}" required>
                                </ng-select>
                            </div>
                            <div class="col-6" *ngIf="measurmentUnitId==100">
                                <label for="Unit"> {{'Unit' | translate}} </label>
                                <input #Unit="ngModel" name="Unit" id="Unit" [(ngModel)]="otherMeasurmentUnit"
                                    type="text" class="form-control" placeholder="{{ 'Unit' | translate }}" />

                            </div>
                        </div>

                        <div class="form-group m-1 row">
                            <div class="col-6">
                                <div class="divformlabel">
                                    <label for="action">{{'action'|translate}}</label>
                                    <span *ngIf="action.invalid" class="alert" style="color: red;
                                    white-space: nowrap;
                                    line-height: 0;
                                    padding: 0;
                                    margin-top: 8px;">
                                        <span *ngIf="action.errors?.required">*</span>
                                    </span>
                                </div>
                                <ng-select #action="ngModel" id="action" class="form-control-select"
                                    [items]="violationactionArr" bindLabel="text" bindValue="id"
                                    [(ngModel)]="violationactionId" [ngModelOptions]="{ standalone: true }"
                                    placeholder="{{'action' | translate}}" required>
                                </ng-select>
                            </div>
                            <div class="col-6" *ngIf="violationactionId==100">
                                <label for="OtherAction"> {{'otherAction' | translate}} </label>
                                <input #OtherAction="ngModel" name="OtherAction" id="OtherAction"
                                    [(ngModel)]="otherAction" type="text" class="form-control"
                                    placeholder="{{ 'otherAction' | translate }}" />

                            </div>
                        </div>
                        <div class="form-group m-1 row">
                            <div class="col-12">
                                <label for="Material"> {{'material' | translate}} </label>
                                <span *ngIf="Material.invalid" class="alert" style="
                                                        color: red;
                                                        white-space: nowrap;
                                                        line-height: 0;
                                                        padding: 0;
                                                        margin-top: 8px;
                                                      ">
                                    <span *ngIf="Material.errors?.required">*</span>
                                </span>

                                <input #Material="ngModel" name="Material" id="Material" [(ngModel)]="material" required
                                    type="text" class="form-control" placeholder="{{ 'material' | translate }}" />

                            </div>
                        </div>
                        <div class="form-group m-1 row">
                            <div class="col-12">
                                <label for="ReachingViolationsMehod"> {{'ReachingViolationsMehod' | translate}} </label>
                                <textarea #ReachingViolationsMehod="ngModel" name="ReachingViolationsMehod"
                                    id="ReachingViolationsMehod" [(ngModel)]="reachingViolationsMehod" type="text"
                                    class="form-control"
                                    placeholder="{{ 'ReachingViolationsMehod' | translate }}"></textarea>

                            </div>
                        </div>
                        <div class="form-group m-1 row">
                            <div  *ngIf="isInsert==true" class="col-lg-6 ">
                                <div class="divformlabel">
                                    <label>{{ "DateOfBuy" | translate }}</label>
                                </div>
                                <datepicker [(maxHijri)]="currentDate" [(maxGreg)]="currentDate" (selectedDateChange)="SelectedDateChange($event)" [selectedDateType]="2">
                                </datepicker>
                            </div>
                            <div  *ngIf="isInsert==false" class="col-lg-6 ">
                                <div class="divformlabel">
                                    <label>{{ "DateOfBuy" | translate }}</label>
                                </div>
                                <datepicker [(selectedDate)]="editedDate" (selectedDateChange)="SelectedDateChange($event)" [selectedDateType]="2"></datepicker>
                            </div>
                            <div class="col-6">
                                <label for="PurchaseSource"> {{'PurchaseSource' | translate}} </label>
                                <span *ngIf="PurchaseSource.invalid" class="alert" style="
                                                        color: red;
                                                        white-space: nowrap;
                                                        line-height: 0;
                                                        padding: 0;
                                                        margin-top: 8px;
                                                      ">
                                    <span *ngIf="PurchaseSource.errors?.required">*</span>
                                </span>

                                <input #PurchaseSource="ngModel" name="PurchaseSource" id="PurchaseSource"
                                    [(ngModel)]="purchaseSource" required type="text" class="form-control"
                                    placeholder="{{ 'PurchaseSource' | translate }}" />

                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
        <div class="modal-footer row" style="justify-content: space-between;padding: 1rem 2rem;">
            <button  *ngIf="isInsert==true" style="color: black;font-weight: bold;" type="button" class="btn btn-primary col-lg-3"
                data-bs-dismiss="modal"
                [disabled]="mainViolationType.invalid || PurchaseSource.invalid || Material.invalid || place.invalid || Quantity.invalid || measurmentUnit.invalid || action.invalid"
                (click)="onCreateViolation(modal);">
                {{"Add" | translate}}
            </button>
            <button  *ngIf="isInsert==false" style="color: black;font-weight: bold;" type="button" class="btn btn-primary col-lg-3"
            data-bs-dismiss="modal"
            [disabled]="mainViolationType.invalid || PurchaseSource.invalid || Material.invalid || subViolationType.invalid || place.invalid || Quantity.invalid || measurmentUnit.invalid || action.invalid"
            (click)="onEditViolation(modal);">
            {{"Edit" | translate}}
        </button>
            <button type="button" class="btn btn-danger col-lg-3" (click)="modal.dismiss('Cross click');">
                {{ "Close" | translate }}
            </button>
        </div>
    </form>

</ng-template>

<!-- عرض المخالفة -->
<ng-template #ShowViolation let-modal>
    <div class="modal-header">
        <h4  class="modal-title">
            {{ 'Show' | translate }}
        </h4>
        <i style="font-size: 20px;" class="fa fa-close" (click)="modal.dismiss('Cross click');"></i>
    </div>
    <form novalidate="">
        <div class="modal-body">
            <div class="form-group  row">
                <div class="col-12 offset-1 ">
                    <div class="card rounded-2  flex-md-row row">
                        <div class="form-group m-1 row">
                            <div class="col-lg-9">
                                    <label for="mainViolationType">{{'mainViolationType'|translate}}</label>
                                    <input #mainViolationType="ngModel" readonly name="mainViolationType" id="mainViolationType" [(ngModel)]="mainViolationTypeName" type="text"
                                    class="form-control" placeholder="{{ 'mainViolationType' | translate }}" />                        
                            </div>
                        </div>
                        <div class="form-group row m-1">
                            <div class="col-9">
                                <label for="subViolationType"> {{'subViolationType' | translate}} </label>
                                <input #subViolationType="ngModel" readonly name="subViolationType" id="subViolationType" [(ngModel)]="subViolationTypeName" type="text"
                                class="form-control" placeholder="{{ 'subViolationType' | translate }}" />
                            </div>
                        </div>
                        <!-- <div class="form-group col-lg-10 m-1">
                            <div class="divformlabel">
                                <label>{{ "violationDescription" | translate }}</label>
                            </div>
                            <textarea [readonly]="subViolationTypeId" #violationDescription="ngModel"
                                name="violationDescription" id="violationDescription"
                                [(ngModel)]="SubViolationDescription" type="text" class="form-control"
                                placeholder="{{ 'violationDescription' | translate }}"></textarea>
                        </div> -->
                        <div class="form-group m-1 row">
                            <div class="col-6">
                                <label for="place"> {{'place' | translate}} </label>
                                
                                <input #place="ngModel" readonly name="place" id="place" [(ngModel)]="Place" type="text"
                                    class="form-control" placeholder="{{ 'place' | translate }}" />

                            </div>
                            <div class="col-6">
                                <label for="Quantity"> {{'quantity' | translate}} </label>
                             
                                <input #Quantity="ngModel" readonly name="Quantity" id="Quantity" [(ngModel)]="quantity"
                                    type="text" (keypress)="numberOnly($event)" class="form-control"
                                    placeholder="{{ 'quantity' | translate }}" />

                            </div>
                        </div>
                        <div class="form-group m-1 row">
                            <div class="col-6">
                                <label for="initalValue"> {{'InitalValue' | translate}} </label>
                               
                                <input readonly #initalValue="ngModel" name="initalValue"
                                    id="initalValue" [(ngModel)]="InitalValue" type="text" class="form-control"
                                    placeholder="{{ 'InitalValue' | translate }}" />

                            </div>
                            <div class="col-6">
                                <label for="location"> {{'Location' | translate}} </label>

                                <input #location="ngModel" name="location" id="location" [(ngModel)]="Location"
                                  readonly  type="text" class="form-control" placeholder="{{ 'Location' | translate }}" />

                            </div>
                        </div>
                        <div class="form-group m-1 row">
                            <div class="col-6">
                                <div class="divformlabel">
                                    <label for="measurmentUnit">{{'measurmentUnit'|translate}}</label>
                                </div>
                                <ng-select #measurmentUnit="ngModel" id="measurmentUnit" class="form-control-select"
                                    [items]="measurmentunitArr" bindLabel="text" bindValue="id"
                                    [(ngModel)]="measurmentUnitId" [ngModelOptions]="{ standalone: true }"
                                    placeholder="{{'measurmentUnit' | translate}}" readonly="true">
                                </ng-select>
                            </div>
                            <div class="col-6" *ngIf="measurmentUnitId==100">
                                <label for="Unit"> {{'Unit' | translate}} </label>
                                <input #Unit="ngModel" name="Unit" id="Unit" [(ngModel)]="otherMeasurmentUnit"
                                 readonly   type="text" class="form-control" placeholder="{{ 'Unit' | translate }}" />

                            </div>
                        </div>

                        <div class="form-group m-1 row">
                            <div class="col-6">
                                <div class="divformlabel">
                                    <label for="action">{{'action'|translate}}</label>
                                     
                                </div>
                                <ng-select #action="ngModel" id="action" class="form-control-select"
                                readonly="true"    [items]="violationactionArr" bindLabel="text" bindValue="id"
                                    [(ngModel)]="violationactionId" [ngModelOptions]="{ standalone: true }"
                                    placeholder="{{'action' | translate}}" >
                                </ng-select>
                            </div>
                            <div class="col-6" *ngIf="violationactionId==100">
                                <label for="OtherAction"> {{'otherAction' | translate}} </label>
                                <input #OtherAction="ngModel" name="OtherAction" id="OtherAction"
                                    [(ngModel)]="otherAction" type="text" class="form-control" readonly
                                    placeholder="{{ 'otherAction' | translate }}" />

                            </div>
                        </div>
                        <div class="form-group m-1 row">
                            <div class="col-12">
                                <label for="Material"> {{'material' | translate}} </label>
                                <input #Material="ngModel" name="Material" id="Material" [(ngModel)]="material" required
                                readonly    type="text" class="form-control" placeholder="{{ 'material' | translate }}" />
                            </div>
                        </div>
                        <div class="form-group m-1 row">
                            <div class="col-12">
                                <label for="ReachingViolationsMehod"> {{'ReachingViolationsMehod' | translate}} </label>
                                <textarea #ReachingViolationsMehod="ngModel" name="ReachingViolationsMehod"
                                    id="ReachingViolationsMehod" [(ngModel)]="reachingViolationsMehod" type="text"
                                    class="form-control" readonly
                                    placeholder="{{ 'ReachingViolationsMehod' | translate }}"></textarea>

                            </div>
                        </div>
                        <div class="form-group m-1 row">
                            <div   class="col-lg-6 ">
                                <div class="divformlabel">
                                    <label>{{ "DateOfBuy" | translate }}</label>
                                </div>
                                <input
                                readonly
                                #DateOfBuy="ngModel"
                                name="DateOfBuy"
                                id="DateOfBuy"
                                [ngModel]="dateOfBuy | toDateOnly" 
                                type="text"
                                class="form-control"
                                placeholder="{{ 'DateOfBuy' | translate }}"
                            />
                            </div>
                            <div class="col-6">
                                <label for="PurchaseSource"> {{'PurchaseSource' | translate}} </label>

                                <input #PurchaseSource="ngModel" name="PurchaseSource" id="PurchaseSource"
                                    [(ngModel)]="purchaseSource" readonly type="text" class="form-control"
                                    placeholder="{{ 'PurchaseSource' | translate }}" />

                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
        <div class="modal-footer row" style="justify-content: space-between;padding: 1rem 2rem;">
            <div class="col-3"></div>
          
            <button type="button" class="btn btn-danger col-lg-3" (click)="modal.dismiss('Cross click');">
                {{ "Close" | translate }}
            </button>
        </div>
    </form>
</ng-template>


 

 



<ng-template #mymodal let-modal>
    <div class="modal-header" style="justify-content: center">
        <h4 class="modal-title" id="modal-basic-title">
            {{ "ConfirmDeleteOperation" | translate }}
        </h4>
    </div>
    <div class="modal-body text-center">
        <p>{{ "SelectedRecordwillbeDeleted" | translate }}</p>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-danger" (click)="onDeleteViolation(modal)">
            {{ "YES" | translate }}
        </button>
        <button type="button" class="btn btn-primary" (click)="modal.dismiss('Cross click')">
            {{ "NO" | translate }}
        </button>
    </div>
</ng-template>